import React from 'react';
import { connect } from 'react-redux';
import {
  Card, CardBody, CardTitle,
} from 'reactstrap';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { bindActionCreators } from 'redux';
import qs from 'qs';
import {
  searchTsunamiEvents as searchTsunamiEventsAc,
  clearRedirect as clearRedirectAc,
  clearTsunamiEventSearch as clearTsunamiEventSearchAc,
} from '../../../../../../redux/tsunamis/event/search/tsunamiEventSearchActions';
import {
  deleteTsunami as deleteTsunamiAc,
  getRunupMeasurementTypes as getRunupMeasurementTypesAc,
  getValidity as getValidityAc,
  getCauses as getCausesAc,
  getRegions as getRegionsAc,
  getRunupRegions as getRunupRegionsAc,
  clearTsunamiData as clearTsunamiDataAc,
  sortData as sortDataAc,
  toggleColumns as toggleColumnsAc,
} from '../../../../../../redux/tsunamis/event/data/tsunamiEventDataActions';
import { isDataManager } from '../../../../../../role/roleUtils';
import { resolveSearchParameters } from '../search/tsunamiSearchParameterNameResolver';
import { Loading } from '../../../../../loadbar/Loading';
import { SearchParamDisplay } from '../../../../../data/SearchParamDisplay';
import { TsunamiDataGrid } from './TsunamiDataGrid';

class TsunamiContainerUnwrapped extends React.Component {
  constructor(props) {
    super(props);
    this.toggleDescriptionModal = this.toggleDescriptionModal.bind(this);
    this.state = {
      queryParameters: {},
    };
  }

  componentDidMount() {
    document.title = 'NCEI Hazard Tsunami Event Results';
    const {
      clearTsunamiData,
      getCauses,
      getRunupMeasurementTypes,
      getValidity,
      getRegions,
      getRunupRegions,
      searchTsunamiEvents,
      clearRedirect,
      searchRedirect,
      location: { search },
      history,
    } = this.props;
    clearTsunamiData();
    getCauses({ history });
    getRunupMeasurementTypes({ history });
    getValidity({ history });
    getRegions({ history });
    getRunupRegions({ history });
    let queryParameters = {};
    if (search.length) {
      queryParameters = qs.parse(search.split('?')[1]);
    }
    if (!searchRedirect) {
      searchTsunamiEvents({ queryParameters, history });
    } else {
      clearRedirect();
    }
    this.setState({ queryParameters });
    window.scrollTo(0, 0);
  }

  componentWillUnmount() {
    const { clearTsunamiEventSearch, clearTsunamiData } = this.props;
    clearTsunamiEventSearch();
    clearTsunamiData();
  }

  toggleDescriptionModal(name) {
    this.setState(state => ({ modals: state.modals.update(name, val => !val) }));
  }

  render() {
    const {
      tsunamiEvents,
      fetched,
      deleting,
      authorities,
      regions,
      runupRegions,
      peopleDescriptors,
      damageDescriptors,
      housesDescriptors,
      validities,
      causes,
      runupMeasurementTypes,
      sort,
      sortData,
      visibleColumns,
      toggleColumns,
      deleteTsunami,
      searchTsunamiEvents,
      history,
    } = this.props;
    const { queryParameters } = this.state;
    const dataManager = isDataManager(authorities);

    if (!fetched) {
      return (<Loading />);
    }

    const sp = resolveSearchParameters({
      params: queryParameters,
      regions,
      runupRegions,
      peopleDescriptors,
      damageDescriptors,
      housesDescriptors,
      validities,
      causes,
      runupMeasurementTypes,
    });

    return (
      <div className="haz-results-container haz-page-container">
        {Boolean(sp.length) && <SearchParamDisplay messages={sp} />}

        <div className="haz-data-grid-container">
          <div className="haz-data-grid-container">
            <Card>
              <CardBody>

                <div className="doiCitation">
                  <span id="doiReference">
                    <p>
                      <a href="http://dx.doi.org/10.7289/V5PN93H7" rel="noopener noreferrer" target="_blank" title="Tsunami Event Information" aria-label="Tsunami Event Information">Please cite DOI:10.7289/V5PN93H7</a>
                    </p>
                  </span>
                </div>

                <CardTitle tag="h2">{`Tsunami Events - ${tsunamiEvents.size} Results Found`}</CardTitle>

                <TsunamiDataGrid
                  tsunamiEvents={tsunamiEvents}
                  dataManager={dataManager}
                  sort={sort}
                  sortData={sortData}
                  visibleColumns={visibleColumns}
                  toggleColumns={toggleColumns}
                  searchParams={JSON.stringify(sp)}
                  deleting={deleting}
                  deleteTsunami={deleteTsunami}
                  onDeleteCloseModal={() => searchTsunamiEvents({ queryParameters, history })}
                />

              </CardBody>
            </Card>
          </div>
        </div>
      </div>
    );
  }
}

TsunamiContainerUnwrapped.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string,
  }).isRequired,
  fetched: PropTypes.bool.isRequired,
  deleting: PropTypes.bool.isRequired,
  tsunamiEvents: ImmutablePropTypes.list.isRequired,
  searchTsunamiEvents: PropTypes.func.isRequired,
  clearTsunamiEventSearch: PropTypes.func.isRequired,
  deleteTsunami: PropTypes.func.isRequired,
  history: PropTypes.shape({}).isRequired,
  clearRedirect: PropTypes.func.isRequired,
  searchRedirect: PropTypes.bool.isRequired,
  authorities: ImmutablePropTypes.list.isRequired,
  getRunupMeasurementTypes: PropTypes.func.isRequired,
  runupMeasurementTypes: ImmutablePropTypes.list.isRequired,
  peopleDescriptors: ImmutablePropTypes.list.isRequired,
  damageDescriptors: ImmutablePropTypes.list.isRequired,
  housesDescriptors: ImmutablePropTypes.list.isRequired,
  validities: ImmutablePropTypes.list.isRequired,
  getValidity: PropTypes.func.isRequired,
  causes: ImmutablePropTypes.list.isRequired,
  getCauses: PropTypes.func.isRequired,
  clearTsunamiData: PropTypes.func.isRequired,
  regions: ImmutablePropTypes.list.isRequired,
  getRegions: PropTypes.func.isRequired,
  runupRegions: ImmutablePropTypes.list.isRequired,
  getRunupRegions: PropTypes.func.isRequired,
  sortData: PropTypes.func.isRequired,
  sort: ImmutablePropTypes.list.isRequired,
  visibleColumns: ImmutablePropTypes.list.isRequired,
  toggleColumns: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  fetched: [
    state.getIn(['tsunamiEventSearchPage', 'fetched']),
    state.getIn(['tsunamiEventDataPage', 'fetchedRegions']),
    state.getIn(['tsunamiEventDataPage', 'fetchedRunupRegions']),
    state.getIn(['tsunamiEventDataPage', 'fetchedRunupMeasurementTypes']),
    state.getIn(['tsunamiEventDataPage', 'fetchedValidities']),
    state.getIn(['tsunamiEventDataPage', 'fetchedCauses']),
  ].every(v => v),
  deleting: state.getIn(['tsunamiEventDataPage', 'deleting']),
  tsunamiEvents: state.getIn(['tsunamiEventSearchPage', 'tsunamiEvents']),
  searchRedirect: state.getIn(['tsunamiEventSearchPage', 'searchRedirect']),
  validities: state.getIn(['tsunamiEventDataPage', 'validities']),
  causes: state.getIn(['tsunamiEventDataPage', 'causes']),
  regions: state.getIn(['tsunamiEventDataPage', 'regions']),
  runupRegions: state.getIn(['tsunamiEventDataPage', 'runupRegions']),
  runupMeasurementTypes: state.getIn(['tsunamiEventDataPage', 'runupMeasurementTypes']),

  damageDescriptors: state.getIn(['effectDescriptors', 'damage']),
  peopleDescriptors: state.getIn(['effectDescriptors', 'people']),
  housesDescriptors: state.getIn(['effectDescriptors', 'houses']),
  sort: state.getIn(['tsunamiEventSearchPage', 'sort']),
  visibleColumns: state.getIn(['tsunamiEventDataPage', 'visibleColumns']),
});

const mapDispatchToProps = dispatch => bindActionCreators({
  searchTsunamiEvents: searchTsunamiEventsAc,
  clearTsunamiEventSearch: clearTsunamiEventSearchAc,
  deleteTsunami: deleteTsunamiAc,
  clearRedirect: clearRedirectAc,
  getRunupMeasurementTypes: getRunupMeasurementTypesAc,
  getValidity: getValidityAc,
  getCauses: getCausesAc,
  getRegions: getRegionsAc,
  getRunupRegions: getRunupRegionsAc,
  clearTsunamiData: clearTsunamiDataAc,
  sortData: sortDataAc,
  toggleColumns: toggleColumnsAc,
}, dispatch);


export const TsunamiContainer = connect(mapStateToProps, mapDispatchToProps)(TsunamiContainerUnwrapped);
